import type { Config } from "./config";

export const getEnvValue = (key: keyof Config): string => {
  return import.meta.env[key];
};
